export const theme = {
  fontSize: {
    '2xs': '0.6rem',
  },
  colors: {
    smoke: {
      '100': 'rgba(0, 0, 0, 0.1)',
      '200': 'rgba(0, 0, 0, 0.2)',
      '300': 'rgba(0, 0, 0, 0.3)',
      '400': 'rgba(0, 0, 0, 0.4)',
      '500': 'rgba(0, 0, 0, 0.5)',
      '600': 'rgba(0, 0, 0, 0.6)',
      '700': 'rgba(0, 0, 0, 0.7)',
      '800': 'rgba(0, 0, 0, 0.8)',
      '900': 'rgba(0, 0, 0, 0.9)',
    },
    frost: {
      '100': 'rgba(255, 255, 255, 0.1)',
      '200': 'rgba(255, 255, 255, 0.2)',
      '300': 'rgba(255, 255, 255, 0.3)',
      '400': 'rgba(255, 255, 255, 0.4)',
      '500': 'rgba(255, 255, 255, 0.5)',
      '600': 'rgba(255, 255, 255, 0.6)',
      '700': 'rgba(255, 255, 255, 0.7)',
      '800': 'rgba(255, 255, 255, 0.8)',
      '900': 'rgba(255, 255, 255, 0.9)',
    },
    jcapFrost: {
      '100': 'rgba(38, 179, 231, 0.2)',
      '200': 'rgba(38, 179, 231, 0.4)',
      '300': 'rgba(38, 179, 231, 0.4)',
      '400': 'rgba(38, 179, 231, 0.45)',
      '500': 'rgba(38, 179, 231, 0.5)',
      '600': 'rgba(38, 179, 231, 0.55)',
      '700': 'rgba(38, 179, 231, 0.6)',
      '800': 'rgba(38, 179, 231, 0.65)',
      '900': 'rgba(38, 179, 231, 0.7)',
    },
    gray: {
      '050': '#fBfdfe',
      '100': '#f7fafc',
      '200': '#edf2f7',
      '300': '#e2e8f0',
      '400': '#cbd5e0',
      '500': '#a0aec0',
      '600': '#718096',
      '650': '#5E6B7F',
      '700': '#4a5568',
      '750': '#3c4658',
      '800': '#2d3748',
      '900': '#1a202c',
    },
    jcap: {
      '100': '#ebf8ff',
      '200': '#bae9fe',
      '300': '#87d8fb',
      '400': '#55c6f3',
      '500': '#0B8FCF',
      '600': '#0D7EB8',
      '700': '#106DA1',
      '800': '#125C8A',
      '900': '#144B73',
      '1000': '#0f3b5a',
    },
  },
  spacing: {
    '14': '3.5rem',
    '18': '4.5rem',
    '22': '5.5rem',
    '60': '14rem',
    '72': '18rem',
    '84': '21rem',
    '96': '24rem',
    '128': '36rem',
  },
  borderRadius: {
    xl: '25px',
  },
};
